module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<button\n  class="sitn-app-tools btn btn-default"\n  ng-click="$ctrl.redirectTo();"\n  data-toggle="tooltip"\n  data-placement="left"\n  data-original-title="{{$ctrl.title}}"\n>\n  <span class="fa {{$ctrl.icon}}"></span>\n</button>\n';

}
return __p
}